import React from "react";
import { useTranslation } from "react-i18next";
import "../App.css";
import HeroSection from "../components/HeroSection/HeroSection";
import FeatureCarousel from "../components/FeatureCarousel/FeatureCarousel";

function Home() {
  const { t } = useTranslation();

  return (
    <>
      <HeroSection />

      <section className="home-trustbar">
        <div className="home-trustbar-item">
          <strong>{t("trustbar.app.title")}</strong>
          <span>{t("trustbar.app.description")}</span>
        </div>
        <div className="home-trustbar-item">
          <strong>{t("trustbar.free.title")}</strong>
          <span>{t("trustbar.free.description")}</span>
        </div>
        <div className="home-trustbar-item">
          <strong>{t("trustbar.cross.title")}</strong>
          <span>{t("trustbar.cross.description")}</span>
        </div>
        <div className="home-trustbar-item">
          <strong>{t("trustbar.dsgvo.title")}</strong>
          <span>{t("trustbar.dsgvo.description")}</span>
        </div>
      </section>
      <FeatureCarousel />
    </>
  );
}

export default Home;
